export { PaymentResultView as PaymentResult } from './View';
